const _import = require('../import-' + process.env.NODE_ENV)

const goodsCretRouter = [
  {
    path: '/goods/cret',
    name: 'goodsCret',
    component: _import('goods/cret'),
    meta: {
      auth: true,
      keepAlive: true,
      title: '万果园商品证件查询'
    }
  },
  {
    path: '/goods/info',
    name: 'goodsInfo',
    component: _import('goods/info'),
    meta: {
      auth: true,
      title: '证件信息'
    }
  },
  {
    path: '/goods/openCret',
    name: 'goodsOpenCret',
    component: _import('goods/openCret'),
    meta: {
      auth: true,
      title: '证件图片'
    }
  },
  {
    path: '/goods/supplier',
    name: 'goodsSupplier',
    component: _import('goods/supplier'),
    meta: {
      auth: true,
      title: '证件信息'
    }
  }
]
export default goodsCretRouter



// WEBPACK FOOTER //
// ./src/router/other/goodsCret.js